import React from "react";
import {Box, FormControlLabel, Radio, Stack} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicRadioSizeLabel = () => {
  return (
    <Box sx={{ mb: 2 }}>
      <PreviewAndEditor
        language={"js"}
        value={
          "        <FormControlLabel\n" +
          '          value="small"\n' +
          '          control={<Radio size="small" />}\n' +
          '          label="Small"\n' +
          "        />\n\n" +
          '        <FormControlLabel value="medium" control={<Radio />} label="Medium" />\n\n' +
          "        <FormControlLabel\n" +
          '          value="large"\n' +
          '          control={<Radio size="large" />}\n' +
          '          label="Large"\n' +
          "        />"
        }
      >
        <Stack direction={"row"} alignItems={"center"} spacing={2}>
          <FormControlLabel
            value="small"
            control={<Radio size="small" />}
            label="Small"
          />
          <FormControlLabel value="medium" control={<Radio />} label="Medium" />
          <FormControlLabel
            value="large"
            control={<Radio size="large" />}
            label="Large"
          />
        </Stack>
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicRadioSizeLabel;
